import { Clock } from "lucide-react";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const DEFAULT = DAYS.map(() => ({ closed: false, open: "11:00", close: "22:00" }));
const timeCls = "bg-slate-800 border border-slate-700 rounded-lg px-2 py-1.5 text-sm font-mono-j focus:outline-none focus:border-orange-500 disabled:opacity-40";

export const OpeningHoursEditor = ({ form, setForm }) => {
  const hours = form.opening_hours;
  const enabled = Array.isArray(hours);

  const toggle = () =>
    setForm((f) => ({
      ...f,
      opening_hours: enabled ? null : DEFAULT,
      timezone: f.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    }));

  const setDay = (i, patch) =>
    setForm((f) => ({ ...f, opening_hours: f.opening_hours.map((d, j) => (j === i ? { ...d, ...patch } : d)) }));

  return (
    <div className="border-b border-slate-800 pb-6 space-y-4" data-testid="opening-hours-section">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-semibold flex items-center gap-1.5"><Clock className="h-4 w-4 text-orange-400" /> Opening hours</p>
          <p className="text-xs text-slate-400">Diners see "Open now" or "Closed", and orders are blocked while closed.{enabled && form.timezone ? ` Time zone: ${form.timezone}` : ""}</p>
        </div>
        <button type="button" data-testid="opening-hours-toggle" onClick={toggle} className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${enabled ? "bg-emerald-600" : "bg-slate-600"}`} aria-label="Use opening hours">
          <span className={`absolute left-0 top-0.5 h-5 w-5 rounded-full bg-white transition-transform ${enabled ? "translate-x-5" : "translate-x-0.5"}`} />
        </button>
      </div>
      {!enabled && <p className="text-xs text-slate-500">Off: you are always open for orders.</p>}
      {enabled && (
        <div className="space-y-2">
          {hours.map((d, i) => (
            <div key={DAYS[i]} data-testid={`hours-row-${i}`} className="flex flex-wrap items-center gap-3">
              <span className="w-24 text-sm">{DAYS[i]}</span>
              <label className="flex items-center gap-1.5 text-xs text-slate-400">
                <input type="checkbox" data-testid={`hours-open-${i}`} checked={!d.closed} onChange={(e) => setDay(i, { closed: !e.target.checked })} className="accent-orange-500" /> Open
              </label>
              <input type="time" required={!d.closed} data-testid={`hours-from-${i}`} disabled={d.closed} value={d.open} onChange={(e) => setDay(i, { open: e.target.value })} className={timeCls} />
              <span className="text-slate-500 text-xs">to</span>
              <input type="time" required={!d.closed} data-testid={`hours-to-${i}`} disabled={d.closed} value={d.close} onChange={(e) => setDay(i, { close: e.target.value })} className={timeCls} />
              {!d.closed && d.close < d.open && <span className="text-[10px] text-slate-500">next day</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
